import React, { useEffect, useState } from "react"
import moment from "moment"
import { AiOutlineClockCircle, AiOutlineCalendar } from "react-icons/ai"

import { apiTransactionCronJob, apiTransactionCronJobUpdateNext } from "../../../../services/Admin/transaction"

import { Box, Modal, Typography, TextField, Button } from "@mui/material"

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    p: 4,
    minWidth: 500,
    maxWidth: 500,
    borderRadius: 3,
    position: "relative"
};


export default function CronJobInfo() {
    const [cronjobInfoLastProcessed, setCronjobInfoLastProcessed] = useState(null)
    const [cronjobInfoLastProcessedModal, setCronjobInfoLastProcessedModal] = useState(null)
    const [cronjobInfoNextPending, setCronjobInfoNextPending] = useState(null)
    const [cronjobInfoNextPendingMonth, setCronjobInfoNextPendingMonth] = useState(null)
    const [cronjobInfoNextPendingYear, setCronjobInfoNextPendingYear] = useState(null)

    const [openModalCronjob, setOpenModalCronjob] = useState(false)
    const [selectedDate, setSelectedDate] = useState("")

    // Calcula rango permitido
    const today = moment().startOf('day')
    const minDate = today.clone().format("YYYY-MM-DD")
    const maxDate = today.clone().add(1, 'month').endOf('month').format("YYYY-MM-DD")

    const getTransactionCronJob = async () => {
        apiTransactionCronJob().then(resp => {
            // Show last_processed as unix UTC timestamp
            const lastProcessed = resp.data?.last
            const nextPending = resp.data?.next
            if (lastProcessed) {
                const meses = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
                const m = moment.parseZone(lastProcessed?.date_prosses)
                const dia = m.format("DD")
                const mes = meses[m.month()]
                const año = m.format("YYYY")
                setCronjobInfoLastProcessed(`${meses[lastProcessed?.invoice_month-1]}, ${lastProcessed?.invoice_year}`)
                setCronjobInfoLastProcessedModal(`${dia} ${mes}, ${año} (${meses[lastProcessed?.invoice_month-1]} ${lastProcessed?.invoice_year})`)
            }
            if (nextPending) {
                const meses = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
                const m = moment.parseZone(nextPending?.date_prosses)
                const dia = m.format("DD")
                const mes = meses[m.month()]
                const año = m.format("YYYY")
                setCronjobInfoNextPending(`${dia} ${mes}, ${año} (${meses[nextPending?.invoice_month-1]} ${nextPending?.invoice_year})`)
                setCronjobInfoNextPendingMonth(nextPending?.invoice_month)
                setCronjobInfoNextPendingYear(nextPending?.invoice_year)
            }
        }).catch(error => {
            console.error(error)
        })
    }

    const handleSaveCronjobInfo = () => {
        setOpenModalCronjob(false)
        if (selectedDate) {
            // Medianoche local del día seleccionado en formato ISO 8601 con timezone
            const tsLocalMidnight = moment(selectedDate, "YYYY-MM-DD")
                .startOf('day')
                .format()
            apiTransactionCronJobUpdateNext({ dateProsses: tsLocalMidnight, month: cronjobInfoNextPendingMonth, year: cronjobInfoNextPendingYear }).then(resp => {
                setOpenModalCronjob(false)
                getTransactionCronJob()
            })
        }
    }

    useEffect(() => {
        getTransactionCronJob()
    }, [])

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    backgroundColor: "#fff",
                    border: "1px solid #dee2e6",
                    borderRadius: "4px",
                    padding: "6px 18px",
                    fontSize: "14px",
                    color: "#333",
                    maxWidth: "fit-content",
                    cursor: "pointer"
                }}
                onClick={() => { setOpenModalCronjob(true) }}
            >
                <span style={{
                    fontWeight: "700",
                    fontSize: "15px",
                    letterSpacing: "0.3px"
                }}>
                    Automatización
                </span>

                {cronjobInfoLastProcessed && (
                    <>
                        <div style={{
                            width: "1px",
                            height: "20px",
                            backgroundColor: "#dee2e6"
                        }} />
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            color: "green"
                        }}>
                            <span style={{ marginTop: "-10px" }}>
                                <AiOutlineClockCircle size={16} color="green" />
                            </span>
                            <span>
                                <strong>Anterior:</strong> {cronjobInfoLastProcessed}
                            </span>
                        </div>
                    </>
                )}

                {cronjobInfoNextPending && (
                    <>
                        <div style={{
                            width: "1px",
                            height: "20px",
                            backgroundColor: "#dee2e6"
                        }} />
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            color: "orange"
                        }}>
                            <span style={{ marginTop: "-10px" }}>
                                <AiOutlineCalendar size={16} color="orange" />
                            </span>
                            <span>
                                <strong>Próxima:</strong> {cronjobInfoNextPending}
                            </span>
                        </div>
                    </>
                )}
            </div>
            <Modal
                open={openModalCronjob}
                onClose={() => setOpenModalCronjob(false)}
                aria-labelledby="modal-cronjob-title"
                aria-describedby="modal-cronjob-description"
                className="text-center"
            >
                <Box sx={style}>
                    <Typography id="modal-cronjob-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                        Información de Automatización
                    </Typography>
                    <Box>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <tbody>
                                <tr>
                                    <td style={{ padding: "8px", textAlign: "left" }}>Última procesada</td>
                                    <td style={{ padding: "8px", textAlign: "right" }}>{cronjobInfoLastProcessedModal || "-"}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "8px", textAlign: "left" }}>Próxima pendiente</td>
                                    <td style={{ padding: "8px", textAlign: "right" }}>{cronjobInfoNextPending || "-"}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Box>
                    <Box>
                        <hr />
                        <Typography variant="body2" color="textSecondary" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                            Modifica la próxima fecha de emisión.
                        </Typography>
                        <Box>
                            <div>
                                <TextField
                                    type="date"
                                    label="Selecciona una fecha"
                                    value={selectedDate}
                                    onChange={e => setSelectedDate(e.target.value)}
                                    inputProps={{
                                        min: minDate,
                                        max: maxDate
                                    }}
                                            InputLabelProps={{ shrink: true }}

                                    fullWidth
                                    size="small"
                                />
                            </div>
                        <Typography variant="body2" color="textSecondary" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, mt: 2 }}>
                            Periodo de facturación para la próxima emisión.
                        </Typography>
                            <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                                <TextField
                                    label="Mes"
                                    type="number"
                                    value={cronjobInfoNextPendingMonth || ''}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    fullWidth
                                    onChange={e => setCronjobInfoNextPendingMonth(e.target.value)}
                                />
                                 <TextField
                                    label="Año"
                                    type="number"
                                    value={cronjobInfoNextPendingYear || ''}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    fullWidth
                                    onChange={e => setCronjobInfoNextPendingYear(e.target.value)}
                                />
                            </div>
                        </Box>
                        <br />
                    </Box>
                    <Box>
                        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16 }}>
                            <div style={{ width: "50%" }}>
                                <Button
                                    onClick={() => setOpenModalCronjob(false)}
                                    variant="contained"
                                    className="MuiButton-containedCancel"
                                    fullWidth
                                >
                                    Cancelar
                                </Button>
                            </div>
                            <div style={{ width: "50%" }}>
                                <Button
                                    onClick={handleSaveCronjobInfo}
                                    color="primary"
                                    variant="contained"
                                    fullWidth
                                    disabled={!selectedDate}
                                >
                                    Guardar
                                </Button>
                            </div>
                        </div>
                    </Box>
                </Box>
            </Modal>
        </>
    )
}